import axios from "axios";
import { useCallback, useContext, useState } from "react";
import { GlobalStates } from "../GlobalStates";

export const useEmail = () => {
    const { token, path, pathImg } = useContext(GlobalStates);

    const sendEmail = useCallback(async (email) => {
        var data = {
            data: {
                from: 'diversity@diversity.lt',
                to: 'diversity@diversity.lt',
                ...email,
            }
        }
        
        try {
            const response = await axios.post(path + 'mail-to', data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            
            return response.data.data;
            
        } catch (error) {
            return null;
        }
    }, [token, path])

    const emailcheck = useCallback(async (email) => {
        try {
            const response = await axios.post(path + 'check-mail', {
                email: email
            });
            return response.data ? true : false;
        } catch (error) {
            return false;
        }
    }, [path])

    const forgotPassword = useCallback(async (email = '') => {
        try {
            await axios.post(path + 'auth/forgot-password', {
                email: email
            });
            return true;
        } catch (error) {
            return false;
        }
    }, [path])

    const newPassword = useCallback(async (code = '', password = '', password2 = '') => {
        try {
            await axios.post(path + 'auth/reset-password', {
                code: code[0],
                password: password,
                passwordConfirmation: password2,
            });
            return true;
        } catch (error) {
            return false;
        }
    }, [path])

    return {
        sendEmail,
        forgotPassword,
        newPassword,
        emailcheck,
    }
}
